// @flow
import React from 'react';
import { Button } from 'reactstrap';
import { Link } from 'react-router-dom';

import { useSelector } from '../../redux/reduxDB';
import { getCartData } from '../../redux/cart';

export default function CartIcon() {
  const [invoice, orderIds] = useSelector(getCartData);

  const isInvoicePending = invoice && invoice.status.toLowerCase() === 'pending';
  const numOrders = orderIds && isInvoicePending && orderIds.length;

  return (
    <Button color="topcart" size="sm">
      <Link to='/cart'>
        <img src="https://s3.amazonaws.com/honeyguide/assets/icons/cart.png" alt="" /> Cart {numOrders ? <div className="indicator"></div> : null}
      </Link>
    </Button >
  );
};



// WEBPACK FOOTER //
// ./src/components/TopBar/CartIcon.js